module.exports = __webpack_public_path__ + "img/banner-web-4.cd8447d4.jpg";